// extracted by mini-css-extract-plugin
export var standaloneTable = "_hz-0";
export var standaloneTableWithBodyFill = "_hz-1";
export var withExtraHeader = "_hz-2";